<template>
  <section id="section-1" class="content-current display-card">
    <div class="card-align">
      <div class="row" id="voucherdata" ref="voucherdata">
        <p v-html="htmldata" ref="document"></p>
      </div>

      <div class="divider"></div>
      <div class="row">
        <div class="col-md-12 btn-align">
          <button type="submit" class="btn btn-primary mr-2" @click="print">
            چاپ
          </button>
          <button type="submit" class="btn btn-primary" @click="toPDF">
            دانلود فایل
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import exportFiles from "../../../../utils/exportFiles";
export default {
  data: function () {
    return {
      htmldata: "",
      voucherNumber: 0,
    };
  },

  created() {
    this.voucherNumber = this.$route.params.id;
    this.getHtmlReserveData();
  },
  methods: {
    getHtmlReserveData() {
      this.$store
        .dispatch("getHotelFlightByVoucherNumber", {
          voucherNumber: this.voucherNumber,
        })
        .then((res) => {
          if (res !== undefined) {
            this.htmldata = res.data;
          } else {

            var id = btoa(this.voucherNumber);

             this.$router.push({
            path: "/vouchers/hotelFlight",
            query: {
              id: id,
            },
          });
          
        // var route=    this.$router.resolve("/vouchers/hotelFlight?id=" + id);
        //       window.open(route.href, "_blank");
          }
        });
    },
    print() {
      this.$htmlToPaper("voucherdata");
    },
    toPDF() {
      var fileName = "PDK_Voucher_" + this.voucherNumber;
      exportFiles.ExportToPDF(this.$refs.voucherdata, fileName, null, null);
    },
  },
};
</script>

<style lang="css" scoped>
.card-align {
  display: table !important;
  text-align: center;
  margin-top: 35px;
}

.display-card {
  display: table;
}
</style>